module.exports = __webpack_public_path__ + "img/13.3c6e7aea.svg";